import gql from 'graphql-tag'

// Update user information
export const saveBirthData = gql`
	mutation($userId: ID!, $birthDate: Json!, $birthPlace: Json!, $birthTime: Json!, $birthSigns: Json!) {
		saveBirthData: updateUser(
			id: $userId
			birthDate: $birthDate
			birthPlace: $birthPlace
			birthTime: $birthTime
			birthSigns: $birthSigns
		) {
				id
			}
	}
`

// Update user name
export const nameUpdateMutation = gql`
	mutation($userId: ID!, $nameFirst: String!, $nameLast: String!) {
		nameUpdate: updateUser(
			id: $userId
			nameFirst: $nameFirst
			nameLast: $nameLast
		) {
			id
		}
	}
`

// Save lookup data
export const lookupUpdateMutation = gql`
	mutation($id: ID!, $lookup: Json!) {
		updateUser(
			id: $id
			lookup: $lookup
		) {
			id
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/user.js